import {
  ActiveLine,
  ActiveText,
  StockBadgeWrapper,
  VehicleToggleButtonWrapper,
} from './VehicleToggleButton.styles';
import {
  DesignTokenSizeEnum,
  Image,
  Text,
  TextAlignment,
  TokenTextAppearance,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';
import { Checkmark } from '@volkswagen-onehub/icons-core';
import Pill from '../Pill/Pill';
import { StyledStockPill } from '../VehicleCard/VehicleCard.styles';
import Box from '../Box/Box';
import useResizeResponsive from '@/hooks/useResizeResponsive';
import { isMobile } from '@/modules/utils/breakpoints';

export enum BackgroundVals {
  TRANSPARENT = 'transparent',
  FILLED = 'filled',
}

export interface VehicleToggleButtonProps {
  active: boolean;
  disabled?: boolean;
  stock?: boolean;
  imageUrl: string;
  title: string;
  text: string;
  stockBadgeLabel?: string;
  stockInfo?: string;
  selectedText?: string;
  background: BackgroundVals;
  id: string;
  onClick?: () => void;
  stockBadgeOpenCallback?: () => void;
  stockBadgeCloseCallback?: () => void;
}

function VehicleToggleButton(props: VehicleToggleButtonProps) {
  const {
    active,
    imageUrl,
    title,
    text,
    disabled,
    stock,
    onClick = () => {},
    stockBadgeLabel,
    stockInfo,
    selectedText,
    background,
    stockBadgeOpenCallback,
    stockBadgeCloseCallback,
  } = props;

  const isMobileWidth = useResizeResponsive(isMobile);

  return (
    <Box
      display="flex"
      flexGrow="1"
      position="relative"
      marginTop={DesignTokenSizeEnum.static250}
    >
      <VehicleToggleButtonWrapper
        active={active}
        disabled={disabled}
        background={background}
        onClick={onClick}
      >
        <Image
          src={imageUrl}
          alt={title}
          width={isMobileWidth ? '200' : '102'}
          height={isMobileWidth ? '110' : '52'}
          objectFit="contain"
        />
        <Text
          appearance={
            disabled ? TokenTextAppearance.copy100 : TokenTextAppearance.bigcopy100
          }
          textAlign={TextAlignment.center}
          bold
        >
          {title}
        </Text>
        <Text
          textAlign={TextAlignment.center}
          appearance={TokenTextAppearance.copy100}
        >
          {text}
        </Text>
        {active && background === BackgroundVals.FILLED && (
          <ActiveText>
            <Text
              appearance={TokenTextAppearance.copy100}
              color={TokenTextColor.inherit}
              bold
            >
              {selectedText}&nbsp;
            </Text>
            <Checkmark variant="small" />
          </ActiveText>
        )}
        {active && <ActiveLine />}
      </VehicleToggleButtonWrapper>
      {stock && (
        <>
          {stockInfo ? (
            <StyledStockPill
              modalProps={{
                description: stockInfo,
                onOpen: stockBadgeOpenCallback,
                onClose: stockBadgeCloseCallback,
              }}
            >
              {stockBadgeLabel}
            </StyledStockPill>
          ) : (
            <StockBadgeWrapper>
              <Pill>{stockBadgeLabel}</Pill>
            </StockBadgeWrapper>
          )}
        </>
      )}
    </Box>
  );
}

export default VehicleToggleButton;
